import { EventStates, EventActions } from "../events/constants";

const state = {
    _tab: 0,
    _route: null,
};

const getters = {
    tab: (s) => s._tab,
    route: (s) => { s._route }
};

const mutations = {
    [EventStates.EVENT_TAB]: (state, payload) => {
        state._tab = payload.tab;
    },

    [EventStates.EVENT_TAB_ROUTE]: (state, payload) => {
        state._route = payload.route;
        if (state._route !== 'eventDetail' && state._route !== 'eventCreate') {
            state._tab = 0;
        }
    },
};

const actions = {
    [EventActions.EVENT_TAB_CHANGE]: ({commit}, payload) => {
        commit(EventStates.EVENT_TAB, payload);
    },

    [EventActions.EVENT_TAB_CHANGE_ROUTE]: ({commit}, payload) => {
        commit(EventStates.EVENT_TAB_ROUTE, payload);
    },
};

export default {
    state,
    getters,
    mutations,
    actions
}

